/* eslint-disable promise/catch-or-return, promise/always-return */
import { testReducedMotion, toArray } from '@nrk/dh-basis-common'

const isVisible = (child) => child.offsetWidth > 0 || child.offsetHeight > 0

export default class ProsentvisVideo extends HTMLElement {
  #intersectionObserver

  static get observedAttributes() {
    return ['data-progress']
  }

  connectedCallback() {
    this._reducedMotion = testReducedMotion()

    /* Preload video when close to viewport */
    this.#intersectionObserver = new IntersectionObserver(
      (intersectionEntries) => {
        if (intersectionEntries?.[0]?.isIntersecting) {
          const videos = this.querySelectorAll('video')
          for (const video of videos) {
            if (window.getComputedStyle(video).display !== 'none') {
              video.setAttribute('preload', 'auto')
            }
          }

          this.#intersectionObserver.disconnect()
          this.#intersectionObserver = null
        }
      },
      {
        threshold: 0,
        rootMargin: '3000px',
      },
    )
    this.#intersectionObserver.observe(this)
  }

  disconnectedCallback() {
    this.#intersectionObserver?.disconnect()
  }

  attributeChangedCallback(name, prevValue, newValue) {
    const valueChanged = prevValue !== newValue
    if (!valueChanged) {
      return
    }

    if (name === 'data-progress') {
      this.#progressChanged()
    }
  }

  async #progressChanged() {
    const seekEnabled = await this.#checkSeek()
    if (!seekEnabled) {
      return
    }
    const videoElement = this.videoElement

    if (!videoElement || !videoElement.duration || this._reducedMotion) {
      return
    }

    videoElement.currentTime = this.progress * videoElement.duration
  }

  async #checkSeek() {
    const videoElement = this.videoElement
    if (videoElement.hasAttribute('data-seek-enabled')) {
      return videoElement.getAttribute('data-seek-enabled') === 'true'
    }

    try {
      await (videoElement.play() || Promise.resolve(true))
      videoElement.pause()
      videoElement.setAttribute('data-seek-enabled', 'true')
      return true
    } catch {
      videoElement.setAttribute('data-seek-enabled', 'false')
      return false
    }
  }

  get videoElement() {
    return toArray(this.children)
      .filter((child) => child.nodeName === 'VIDEO')
      .find(isVisible)
  }

  get progress() {
    return parseFloat(this.getAttribute('data-progress') || '0.0')
  }

  set progress(val) {
    this.setAttribute('data-progress', val.toFixed(4))
  }
}
